import React from "react";
import objectAssign from "object-assign";
const Iframe = _ref => {
  let url = _ref.url,
    allowFullScreen = _ref.allowFullScreen,
    position = _ref.position,
    display = _ref.display,
    height = _ref.height,
    width = _ref.width,
    overflow = _ref.overflow,
    styles = _ref.styles,
    onLoad = _ref.onLoad,
    onMouseOver = _ref.onMouseOver,
    onMouseOut = _ref.onMouseOut,
    scrolling = _ref.scrolling,
    id = _ref.id,
    frameBorder = _ref.frameBorder,
    ariaHidden = _ref.ariaHidden,
    sandbox = _ref.sandbox,
    allow = _ref.allow,
    className = _ref.className,
    title = _ref.title,
    ariaLabel = _ref.ariaLabel,
    ariaLabelledby = _ref.ariaLabelledby,
    name = _ref.name,
    target = _ref.target,
    loading = _ref.loading,
    importance = _ref.importance,
    referrerpolicy = _ref.referrerpolicy,
    allowpaymentrequest = _ref.allowpaymentrequest,
    src = _ref.src,
    key = _ref.key;
  const defaultProps = objectAssign({
    src: src || url,
    target: target || null,
    style: {
      position: position || null,
      display: display || "initial",
      overflow: overflow || null
    },
    scrolling: scrolling || null,
    allowpaymentrequest: allowpaymentrequest || null,
    importance: importance || null,
    sandbox: sandbox && [...sandbox].join(" ") || null,
    loading: loading || null,
    styles: styles || null,
    name: name || null,
    className: className || null,
    allowFullScreen: "allowFullScreen" || null,
    referrerpolicy: referrerpolicy || null,
    title: title || null,
    allow: allow || null,
    id: id || null,
    "aria-labelledby": ariaLabelledby || null,
    "aria-hidden": ariaHidden || null,
    "aria-label": ariaLabel || null,
    width: width || null,
    height: height || null,
    onLoad: onLoad || null,
    onMouseOver: onMouseOver || null,
    onMouseOut: onMouseOut || null,
    key: key || "iframe"
  });
  let props = Object.create(null);
  for (let prop of Object.keys(defaultProps)) {
    if (defaultProps[prop] != null) {
      props[prop] = defaultProps[prop];
    }
  }
  for (let i of Object.keys(props.style)) {
    if (props.style[i] == null) {
      delete props.style[i];
    }
  }
  if (props.styles) {
    for (let key of Object.keys(props.styles)) {
      if (props.styles.hasOwnProperty(key)) {
        props.style[key] = props.styles[key];
      }
      if (Object.keys(props.styles).pop() == key) {
        delete props.styles;
      }
    }
  }
  if (allowFullScreen) {
    if ("allow" in props) {
      const currentAllow = props.allow.replace("fullscreen", "");
      props.allow = `fullscreen ${currentAllow.trim()}`.trim();
    } else {
      props.allow = "fullscreen";
    }
  }
  if (frameBorder >= 0) {
    if (!props.style.hasOwnProperty("border")) {
      props.style.border = frameBorder;
    }
  }
  return /*#__PURE__*/React.createElement("iframe", Object.assign({}, props));
};
export default Iframe;